var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04 0.356397C3.21941 0.13204 3.50098 0 3.8 0H15.2C15.499 0 15.7806 0.13204 15.96 0.356397L18.81 3.92036C18.9333 4.07459 19 4.26217 19 4.45496V16.9288C19 17.6378 18.6997 18.3176 18.1653 18.8189C17.6308 19.3202 16.9059 19.6018 16.15 19.6018H2.85C2.09413 19.6018 1.36922 19.3202 0.834746 18.8189C0.300267 18.3176 0 17.6378 0 16.9288V4.45496C0 4.26217 0.066669 4.07459 0.19 3.92036L3.04 0.356397ZM4.275 1.78198L1.9 4.75195V16.9288C1.9 17.1651 2.00009 17.3918 2.17825 17.5589C2.35641 17.726 2.59804 17.8198 2.85 17.8198H16.15C16.402 17.8198 16.6436 17.726 16.8218 17.5589C16.9999 17.3918 17.1 17.1651 17.1 16.9288V4.75195L14.725 1.78198H4.275Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.12665C0 3.55687 0.42533 3.09497 0.95 3.09497H18.05C18.5747 3.09497 19 3.55687 19 4.12665C19 4.69642 18.5747 5.15832 18.05 5.15832H0.95C0.42533 5.15832 0 4.69642 0 4.12665Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47646 7.22168C6.032 7.22168 6.48235 7.60659 6.48235 8.08141C6.48235 8.76545 6.80028 9.42148 7.36619 9.90517C7.93211 10.3889 8.69966 10.6606 9.49999 10.6606C10.3003 10.6606 11.0679 10.3889 11.6338 9.90517C12.1997 9.42148 12.5176 8.76545 12.5176 8.08141C12.5176 7.60659 12.968 7.22168 13.5235 7.22168C14.0791 7.22168 14.5294 7.60659 14.5294 8.08141C14.5294 9.22148 13.9995 10.3149 13.0563 11.121C12.1131 11.9272 10.8339 12.38 9.49999 12.38C8.16611 12.38 6.88686 11.9272 5.94366 11.121C5.00046 10.3149 4.47058 9.22148 4.47058 8.08141C4.47058 7.60659 4.92093 7.22168 5.47646 7.22168Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.e2780e9cc0f492fa834d04cd79b4c5bb.svg";
export { ForwardRef as ReactComponent };